/**
 * The third parties the formal Privacy Policy names, in display order.
 *
 * PrivacyPolicy.tsx renders `privacy.thirdParty.<id>.title/.content` from this
 * list, and `locales/docs/privacyPolicy.test.ts` fails if any locale lacks one.
 * Every service that receives user data from Sokuji belongs here: hosting and
 * payments first, then analytics, then the AI providers, then services the
 * apps contact directly (Microsoft's online engines in local inference, model
 * downloads, desktop updates).
 */
export const POLICY_THIRD_PARTIES = [
  'cloudflare',
  'zoho',
  'stripe',
  'posthog',
  'soniox',
  'alibaba',
  'openai',
  'google',
  'palabra',
  'bytedance',
  'microsoft',
  'huggingface',
  'github',
] as const;
